import { useQuery } from '@tanstack/react-query';

import { REACT_APP_API_FETCH_INTERVAL } from '#shared';

import { weatherApi } from '../aviationWeather.api';

import type { Sigmet } from '#entities';

export const useQueryISigmets = () =>
  useQuery({
    queryKey: ['weather', 'iSigmet'],
    queryFn: weatherApi.getISegmet,
    select: data => data as Sigmet[],
    refetchInterval: 1000 * REACT_APP_API_FETCH_INTERVAL,
    refetchIntervalInBackground: true,
  });
